import React from 'react';
import Icon from 'components/Icon';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import moment from 'moment-timezone';
import Text from 'components/Text';

type Props = {
  startDateTime: string;
  endDateTime: string;
  onRemove?: () => void;
};

export default function CoachingAvailabilityMultiDayRow(props: Props) {
  return (
    <MediaObject figure="right" center key={props.startDateTime}>
      <Text size="medium" weight="semibold" lineHeight="large">
        {moment(props.startDateTime).format('ddd, MMM D')} -{' '}
        {moment(props.endDateTime).format('ddd, MMM D')}
      </Text>
      {props.onRemove ? (
        <Link onClick={props.onRemove} data-test="remove-time-off">
          <Text align="right" element="div" lineHeight="flush">
            <Icon name="x" color="graphite" size="small" />
          </Text>
        </Link>
      ) : (
        <span />
      )}
    </MediaObject>
  );
}
